module.exports = __webpack_public_path__ + "media/public/img/sponsors/Tour-eaef056d5804ef9203440f724a446cc4.jpg";